import React, { Component } from 'react';
import { Link } from 'react-scroll';
import { Menu, Image } from 'semantic-ui-react';
import siteConfig from 'siteConfig.js';
import './Hero.sass';

class Hero extends Component {
	render() {

		let menuItems = siteConfig.impactSpaces.map((el, idx) => {
			let menuStyles = {
				backgroundColor: el.color,
				color: 'white',
			};

			return (
				<Link activeClass='active' id={'header-link-' + el.id} spy={true} smooth={true} to={el.id} key={idx} offset={-150} >
					<Menu.Item style={menuStyles}>
						<Image src={el.icon}></Image>
						{el.title}
					</Menu.Item>
				</Link>

			)
		});


		return (
			<header className="hero">
				<h1>Impact Spaces</h1>
				<p>
					Your hack can be a potential solution for our community’s greatest pain points! The Impact Spaces provides a high-level overview of various problems each presented industries are facing; from technological constraints to building community spaces, you have a wide range of solutions to work on. Use the Impact Spaces to learn about an industry, build a solution and discover how to apply new technologies, hardware components, and innovative practices into the industry prompts.

				</p>
				<Menu fluid vertical>{menuItems}</Menu>
			</header>
		);
	}
}

export default Hero;
